<template>
  <Popover class="popover">
    <div class="popover__body">
      <UserEntity :username="username" layout="inline" />
      <LastKnownLocation
        v-if="lastKnownHeartbeat && username === lastKnownHeartbeat.username"
        :heartbeat="lastKnownHeartbeat"
      />
    </div>
    <template slot="footer">
      <UserActions :username="username" class="justify-content-end" />
    </template>
  </Popover>
</template>

<script>
import Popover from '@/components/ui/Popover';
import UserEntity from '@/components/users/UserEntity';
import UserActions from '@/components/users/UserActions';
import LastKnownLocation from '@/components/users/LastKnownLocation';
import { mapState } from 'vuex';

export default {
  components: {
    Popover,
    UserEntity,
    UserActions,
    LastKnownLocation,
  },

  props: {
    username: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('live', ['lastKnownHeartbeat']),
  },
};
</script>

<style lang="scss">
.popover {
  // Popovers within the map wrongly inherits the map "move" cursor
  cursor: default;
}
</style>
